/**
 * Replaces underscores with spaces and coverts words into title case.
 * Example: `__custom_field_name` becomes `Custom Field Name`.
 * Based on [this function](https://gitlab.zapier.com/editor/editor/-/blob/main/packages/editor-core/src/utils/humanize.ts) in the editor.
 */
const humanize = (text: string) =>
  text
    .replace(/_+/g, ' ')
    .replace(
      /(\w+)/g,
      (match) => match.charAt(0).toUpperCase() + match.slice(1)
    )
    .trim();

export default humanize;
